import { UserWebsite } from '../../types/UserWebsite';
import { Theme } from '../../types/Theme';
import { WebsiteState, WebsiteType } from '../../types/website.types';
import { webBuilderRequest } from './api.utils';
import { Editor } from 'grapesjs';
import { generateAllPagesHtml } from '../websiteSaving.utils';

export const fetchWebsite = async (websiteId: string, websiteType: WebsiteType): Promise<UserWebsite | Theme> => {
  const endpointPath = websiteType === 'theme' ? '/admin/v1/themes' : '/client/v1/websites';
  const result = await webBuilderRequest(`${endpointPath}/${websiteId}`, { method: 'GET' });
  ['draft', 'published'].forEach(state => {
    if (result[state]?.pages) {
      result[state].pages = result[state].pages.map((page: any) => {
        return {
          ...page.data,
          html: page.html,
        };
      });
    }
    if (result[state]?.data) {
      const { assets, custom, styles, symbols, dataSources } = result[state].data;
      result[state].assets = assets || [];
      result[state].custom = custom || {};
      result[state].styles = styles || [];
      result[state].symbols = symbols || [];
      result[state].dataSources = dataSources || [];
      delete result[state].data;
    }
  });
  return new UserWebsite(result);
};

export const saveWebsite = async (websiteId: string, websiteType: WebsiteType, website: object): Promise<void> => {
  const endpointPath = websiteType === 'theme' ? '/admin/v1/themes' : '/client/v1/websites';
  await webBuilderRequest(`${endpointPath}/${websiteId}`, { method: 'POST', body: { draft: website } });
};

export const saveWebsiteWithHtml = async (
  websiteId: string,
  websiteType: WebsiteType,
  project: any,
  editor: Editor,
  userWebsiteObject?: UserWebsite | null
): Promise<void> => {
  const endpointPath = websiteType === 'theme' ? '/admin/v1/themes' : '/client/v1/websites';

  const pagesHtml = generateAllPagesHtml(editor, userWebsiteObject);

  const { pages, assets, styles, symbols, dataSources, custom, ...rest } = project;

  const enhancedProject = {
    pages:
      project.pages?.map((page: any) => {
        const { html: _, ...pageData } = page;
        return {
          data: pageData,
          html: pagesHtml.find((p: any) => p.id === page.id)?.html,
        };
      }) || [],
    data: {
      assets: assets || [],
      custom: custom || {},
      styles: styles || [],
      symbols: symbols || [],
      dataSources: dataSources || [],
    },
    ...rest,
  };

  const websiteData = {
    draft: enhancedProject,
  };

  await webBuilderRequest(`${endpointPath}/${websiteId}`, {
    method: 'POST',
    body: websiteData,
  });
};

export const getWebsiteLookupDataFromUrl = (searchParams: URLSearchParams) => {
  const websiteId = searchParams.get('websiteId');
  const websiteState: WebsiteState = searchParams.get('state') as WebsiteState;
  const websiteType: WebsiteType = searchParams.get('type') as WebsiteType;

  return {
    websiteId,
    websiteState,
    websiteType,
  };
};
